// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UOwE","label":"styles_label__1eaKc"};